<template>
  <div>
    <b-row class="ml-1 mr-1 mt-1">
      <b-select v-model="perPage" :options="pageOptions" style="width: 4rem" class="pageSizeClass mt-1 ">
      </b-select>
      <unit-selector :selectedUnitId="this.selectedUnitId" @input-change="unitChanged" :disableSelect="this.usersAccessibleUnits.length == 1" style="width: 50rem" class="ml-1 my-auto unitSelector" v-if="this.usersAccessibleUnits != null" />
      <label class="ml-1 my-auto">{{$t('support.activeMembers')}}</label>
      <h3><b-badge class="ml-1" size="lg" :variant="this.supportMembersList.length > 14 ? 'danger' : 'success'"> {{this.supportMembersList.length}}/15</b-badge></h3>
      <b-button class="ml-auto esep-blue-bg" variant="primary" v-if="this.currentCommission != null && this.canCommissionExpire(this.currentCommission.id)"
                @click="showWithdrawSupportFn">
        {{ $t('support.withdrawSupport')}}
      </b-button>
      <b-button class="ml-auto esep-blue-bg" variant="primary" v-if="this.currentCommission != null && this.isAdmin"
                @click="updateDateFn">
        {{ $t('support.changeDueDate')}}
      </b-button>
    </b-row>
    <b-table
      id="support-members-table"
      striped
      hover
      borderless
      v-if="this.savedTitles != null"
      :items="supportMembersList"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >

      <template v-slot:cell(id)="data">
        {{ data.item.member.id }}
      </template>

      <template v-slot:cell(surName)="data">
        {{ data.item.member.surName }}
      </template>

      <template v-slot:cell(firstName)="data">
        {{ data.item.member.firstName }}
      </template>

      <template v-slot:cell(orgUnit)="data">
        {{ data.item.member.orgUnit.name }}
      </template>

      <template v-slot:cell(census)="data">
        <template v-if="data.item.member.lastYearCensus == currentCensusYear">
          <span class="h5"> <b-icon icon="check2-square"></b-icon> </span>
        </template>
        <template v-else>
          <span class="h6 font-weight-bold">
            <b-icon icon="x-square"></b-icon>
          </span>
        </template>
      </template>

      <!-- <template v-slot:cell(title)="data">
        <b-select :disabled="!canEdit" v-model="data.item.title" :options="titles" @change="changeMemberTitle(data.item)" size="sm">
        </b-select>
      </template> -->

      <template v-slot:cell(warnings)="data">
        <template v-if="data.item.numberOfContinuous > 0">
          {{ $t('support.timesInCommission', { number : data.item.numberOfContinuous } ) }}
        </template>

      </template> 

      <template v-slot:cell(action)="data">
        <template>
          <b-button
            size="sm"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('support.editTitles')"
            @click="showEditMember(data.item)"
          >
            <b-icon icon="pencil-square"></b-icon>
          </b-button>
          <b-button
            size="sm"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('support.deleteMember')"
            @click="showDeleteMember(data.item)"
          >
            <b-icon icon="trash"></b-icon>
          </b-button>
        </template>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("support.emptyTable") }}</h6>
      </template>
    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="members-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import memberService from '../../services/member.service';
import unitSelector from '../common/unitSelector.vue';
import {prettifyDate} from "@/services/utils";

export default {
  components: { unitSelector },
  computed: {
    isAdmin() {
      let isAdmin = false;
      for (let i = 0; i < this.$store.state.userInfo.roles.length; i++) {
        if (this.$store.state.userInfo.roles[i].name == "ADMIN") {
          isAdmin = true;
        }
      }
      return isAdmin;
    },
    rows() {
      return this.supportMembersList.length;
    },
    canModSelectedUnit() {
      let canMod = false;
      this.$log.debug(this.$store.state.selectedUnit);
      this.$log.debug(this.$store.state.usersModableUnits);
      if(this.$store.state.selectedUnit && this.$store.state.usersModableUnits ) {
        let unitId = this.$store.state.selectedUnit.id;
        this.$store.state.usersModableUnits.forEach(unit => {
          if(unit.id == unitId) { 
            canMod = true;
          }
        })
      }
      return canMod;
    },
  },
  props: {
    supportMembersList: {
      type: Array
    },
    usersAccessibleUnits: {
      type: Array
    },
    selectedUnitId: {
      type: Number
    },
    currentCommission: {
      type: Object
    },
    expirableCommissions: {
      type: Array
    }
  },
  mounted() {
    this.savedTitles = [];
    this.supportMembersList.forEach(member => {
      this.savedTitles.push({id: member.id, title: member.title});
    });
    this.$store.state.userInfo.roles.forEach( role => {
      if(this.canModSelectedUnit || role.name == 'ADMIN') {
        this.canEdit = true;
        this.fields.push({ key: "action", label: "Ενέργεια", sortable: false , tdClass: 'actionClass' });
      }
    });
    this.getCensusPeriod();
  },
  data() {
    return {
      fields: [
        { key: "id", label: "Αριθμός Μητρώου", sortable: false, thClass: 'text-left', tdClass: 'text-left' }, // needs to be translated
        { key: "surName", label: "Επώνυμο", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "firstName", label: "Όνομα", sortable: false, thClass: 'text-left', tdClass: 'text-left' },
        { key: "dueDate", label: "Ημ. Λήξης", sortable: false, formatter:"prettifyDate" },
        { key: "census", label: "Απογραφή", sortable: false },
        { key: "title", label: "Καθήκοντα", sortable: false , formatter: "translateTitle", thClass: 'text-left', tdClass: 'text-left' },
        { key: "orgUnit", label: "Κλιμάκιο", sortable: false, thClass: 'text-left', tdClass: 'text-left'},
        { key: "warnings", label: "Ειδοποιήσεις", sortable: false },
      ],
      perPage: 20,
      currentPage: 1,
      pageOptions: [ 10, 20],
      userInfo: null,
      currentCensusYear: null,
      savedTitles: null,
    }
  },
  methods: {
    prettifyDate (stringDate) {
      return prettifyDate(stringDate);
    },
    getCensusPeriod() {
      memberService.getCurrentCensusPeriod().then(
        (response) => {
          this.currentCensusYear = response.data.yearCensus;
        },
        (error) => {
          this.errorMessage =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
          this.$log.debug(this.errorMessage);
        }
      );
    },
    unitChanged(displayUnit) {
      if (displayUnit.id) {
        this.$store.state.globalUnitId = String(displayUnit.id);
        localStorage.setItem('global-selected-unit-id', String(displayUnit.id));
      } else {
        this.$store.state.globalUnitId = null;
        localStorage.clear('global-selected-unit-id');
      }
      this.$emit('unit-changed', displayUnit);
    },
    canCommissionExpire(commissionId) {
      let canExpire = false;
      this.expirableCommissions.forEach(comm => {
        if(comm.id == commissionId) {
          canExpire = true;
        }
      })
      return canExpire;
    },
    showDeleteMember(member) {
      this.$emit('show-delete',member);
    },
    showEditMember(member) {
      this.$emit('update-member', member);
    },
    showWithdrawSupportFn() {
      this.$emit('show-withdraw-support',true)
    },
    updateDateFn() {
      this.$emit('show-update-due-date',true)
    },
    translateTitle(title) {
      return this.$t(`supportEnums.${title}`);
    }
  }
  
}
</script>